import EditSvg from '../assets/img/svg/edit'
import AmoCRM from '../ui/amocrm'
import Bitrix24 from '../ui/bitrix24'
import Checkbox from './checkbox'
import API from '../hooks/requests'
import amoEventConst from '../const/amo-event'
import amoActionConst from '../const/amo-action'
import bitrixEventConst from '../const/bitrix24-event'
import bitrixActionConst from '../const/bitrix24-action'

const GridMain = ({ setEditBundle, dataList, setDataList }) => {
  const getFromLabel = (i, v) => {
    const arr = i === 'amocrm' ? amoEventConst : bitrixEventConst
    return (
      <>
        {i === 'amocrm' ? <AmoCRM /> : <Bitrix24 />}{' '}
        {arr.find(({ value }) => value === v)?.label}
      </>
    )
  }

  const getToLabel = (i, v) => {
    const arr = i === 'amocrm' ? amoActionConst : bitrixActionConst
    return (
      <>
        {i === 'amocrm' ? <AmoCRM /> : <Bitrix24 />}{' '}
        {arr.find(({ value }) => value === v)?.label}
      </>
    )
  }
  return (
    <>
      <div className="grid-head">
        <span>ID</span>
        <span>Source</span>
        <span>Action</span>
      </div>
      <div className="grid-flex">
        {dataList &&
          dataList.map((e) => {
            return (
              <div
                className={`grid-table${e.soft_delete ? '-delete' : ''}`}
                key={e.id}
              >
                <span className="grid-id">#{e.id}</span>
                <span className="grid-item">
                  {getFromLabel(e.from_crm, e.from_trigger)}
                </span>
                <span className="grid-item">
                  {getToLabel(e.to_crm, e.to_action)}
                </span>
                <div className="grid-menu">
                  <Checkbox
                    status={e.status}
                    callback={() => {
                      if (!e.soft_delete) {
                        setDataList((dataList) =>
                          dataList.map((m) =>
                            m.id === e.id ? { ...m, status: !e.status } : m
                          )
                        )
                        API.changeBundleStatus(e.id, e.status)
                      }
                    }}
                  />
                  <EditSvg
                    onClick={() => {
                      if (!e.soft_delete) {
                        setEditBundle(e)
                      }
                    }}
                  />
                </div>
              </div>
            )
          })}{' '}
      </div>
    </>
  )
}

export default GridMain
